module.exports = __webpack_public_path__ + "static/media/arc-logo.127e1c1e.gif";